import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/img/header-logo.png';
import { reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeaderBar',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const isShowHeader = ref(true);
        const menus = reactive([
            {
                path: '/',
                title: '关于我们',
            },
            {
                path: '/business',
                title: '业务介绍',
            },
            // {
            //   path: 'https://naxions.jobs.feishu.cn/index',
            //   title: '招贤纳士',
            // },
            {
                path: '/address',
                title: '联系我们',
            },
        ]);
        function toPath(path) {
            if (path.includes('https')) {
                window.open(path);
                try {
                    window.saTrack('open', {
                        firstStage: 'Employment',
                    });
                }
                catch { }
                return;
            }
            router.push(path);
        }
        let sign = 60; // 定义默认的向上滚与向下滚的边界
        window.addEventListener('scroll', (e) => {
            const oScrollTop = e.target.scrollingElement.scrollTop;
            if (oScrollTop > 60) {
                if (oScrollTop > sign) {
                    sign = oScrollTop;
                    isShowHeader.value = false;
                }
                else {
                    sign = oScrollTop;
                    isShowHeader.value = true;
                }
            }
            else {
                isShowHeader.value = true;
            }
        });
        return (_ctx, _cache) => {
            const _component_a_menu_item = _resolveComponent("a-menu-item");
            const _component_a_menu = _resolveComponent("a-menu");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['header', isShowHeader.value && 'active'])
            }, [
                _createElementVNode("img", {
                    class: "logo",
                    src: _imports_0,
                    onClick: _cache[0] || (_cache[0] = ($event) => (toPath('/')))
                }),
                _createVNode(_component_a_menu, {
                    class: "menu",
                    mode: "horizontal",
                    "show-collapse-button": "",
                    breakpoint: "md",
                    "selected-keys": [_unref(route).path],
                    "default-selected-keys": ['/']
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus, (item) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: item.path,
                                class: "",
                                onClick: ($event) => (toPath(item.path))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                            }, 1032, ["onClick"]));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["selected-keys"])
            ], 2));
        };
    }
});
